import React from 'react';
import { FadeInSection } from '../ui/MotionPrimitives';

const CorporateEthos: React.FC = () => {
  return (
    <FadeInSection className="w-full bg-white py-16">
      <div className="mx-auto max-w-5xl px-6 md:px-10">
        <p className="text-xs font-semibold uppercase tracking-[0.18em] text-black">
          Corporate Ethos
        </p>
        <h2 className="mt-2 text-3xl font-semibold tracking-tight text-black md:text-4xl">
          Integrity, Insight, and Partnership (Our Approach)
        </h2>
        <div className="mt-5 space-y-4 text-sm leading-relaxed text-black md:text-base">
          <p>
            We believe that success in real estate is not just about transactions, but about
            creating meaningful and enduring relationships.
          </p>
          <p>
            Whether you are a buyer, seller, investor, or partner, we work closely with you to
            navigate the ever-evolving real estate landscape, ensuring your goals are achieved.
          </p>
          <p>
            Our team&apos;s commitment to integrity, personalized service, and strategic insight makes
            us a trusted partner for those looking to invest in real estate in both the UAE and the
            USA.
          </p>
        </div>
        <p className="mt-8 text-sm font-semibold uppercase tracking-[0.18em] text-black">
          Strategic Real Estate. Global Impact
        </p>
      </div>
    </FadeInSection>
  );
};

export default CorporateEthos;
